import { HttpService } from './store/http/http.service';
import { MSEditorService } from './components/ms-editor/ms-editor.service';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ServerService } from './server.service';

// Components
import { AppComponent } from './app.component';

// Services
import { KeyHandlerService } from './services/keyhandler/keyhandler.service';
import { CanvasService } from './services/canvas/canvas.service';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { BaseReducer } from './store/reducer';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { StoreService } from './store/store.service';
import { StoreEffects } from './store/effect/effect';

import { FlexLayoutModule } from '@angular/flex-layout';
import { MaterialModule } from './material.module';
import { TypeService } from './components/data-editor/type.service';

import { ComponentsModule } from './components/components.module';
import { MetaScriptModule } from './ms/metascript.module';
import { HttpCacheInterceptorModule } from '@ngneat/cashew';

import { SignUpComponent } from './sign-up/sign-up.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { ProfileComponent } from './profile/profile.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';
import { EditorModule } from './element-editor/element-editor.module';
import { AuthenticationModule } from './authentication/authentication.module';
import { OrganisationModule } from './organisation/organisation.module';
import { ProjectModule } from './projects/project.module';
import { UserModule } from './user/user.module';
import { HomeModule } from './home/home.module';
import { LabModule } from './lab/lab.module';
import { APIConfig } from './api/api-config.provider';
import { NewProjectComponentComponent } from './new/new-project-component/new-project-component.component';
import { ProjectOverviewComponent } from './project-overview/project-overview.component';
import { UtilComponentModule } from './components/util/util-component.module';
import { DirectivesModule } from './directives/directives.module';
import { A11yModule } from '@angular/cdk/a11y';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { ColorEditorOverlayComponent } from './shared/overlays/color-editor-overlay/color-editor-overlay.component';
import { ProjectPreviewLoadingComponent } from './shared/project-preview-loading/project-preview-loading.component';

@NgModule({
  declarations: [
    AppComponent,
    SignUpComponent,
    SignInComponent,
    ProfileComponent,
    ColorEditorOverlayComponent,

    NewProjectComponentComponent,
    ProjectOverviewComponent,
    ProjectPreviewLoadingComponent,
  ],
  imports: [
    ComponentsModule,
    UtilComponentModule,
    BrowserAnimationsModule,
    BrowserModule,
    DirectivesModule,
    FlexLayoutModule,
    FormsModule,
    HttpClientModule,
    HttpCacheInterceptorModule.forRoot(),
    MaterialModule,
    // ShapeAttributePanelModule,
    EffectsModule.forRoot([StoreEffects]),
    StoreModule.forRoot(BaseReducer),
    !environment.production
      ? StoreDevtoolsModule.instrument({ maxAge: 25 })
      : [],
    MetaScriptModule,
    AppRoutingModule,
    EditorModule,
    // SidePanelModule,
    AuthenticationModule,
    OrganisationModule,
    ProjectModule,
    UserModule,
    HomeModule,
    LabModule,
    A11yModule,
    DragDropModule,
  ],
  providers: [
    // useHttpCacheLocalStorage,
    CanvasService,
    KeyHandlerService,
    MSEditorService,
    ServerService,
    StoreService,
    TypeService,
    StoreEffects,
    HttpService,
    APIConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: (apiConfig: APIConfig) => () => apiConfig.loadConfig(),
      deps: [APIConfig],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() {
    console.log(
      `App version: ${environment.version} (${
        environment.production ? 'production' : 'development'
      })`,
    );
    // if (!environment.production) {
    //   router.events
    //     .pipe(filter(event => event instanceof NavigationEnd))
    //     .subscribe(event => console.log(activatedRoute.snapshot));
    // }
  }
}
